import { MobileMenuBar } from '../helpers/mobile-menu-bar';
import { initFooterNewsletterForm } from '../forms/validator/validations/footer-newsletter-form';
import { Header } from './header';
import { VisitorTracker } from '../components/visitor-tracker';
import { initVisualViewportInset } from './visual-viewport-inset';

export default class Frontend {

    public init() : void {
        MobileMenuBar.initMobileMenuBar();
        initFooterNewsletterForm('mobile');
        initFooterNewsletterForm('desktop');
        new Header();
        VisitorTracker.trackVisitor();
        initVisualViewportInset();
    }

}
